import service from '@/utils/request'

export function settingNoticeGet(data) {
  return service({
    url: '/api/setting/notice/get',
    method: 'post',
    data
  })
}

export function settingNoticeEdit(data) {
  return service({
    url: '/api/setting/notice/edit',
    method: 'post',
    data
  })
}

export function settingLinkList(data) {
  return service({
    url: '/api/setting/link/list',
    method: 'post',
    data
  })
}

export function settingLinkEdit(data) {
  return service({
    url: '/api/setting/link/edit',
    method: 'post',
    data
  })
}

export function settingFinalLinkList(data) {
  return service({
    url: '/api/setting/final/link/list',
    method: 'post',
    data
  })
}

export function settingFinalLinkEdit(data) {
  return service({
    url: '/api/setting/final/link/edit',
    method: 'post',
    data
  })
}

export function settingGet(data) {
  return service({
    url: '/api/setting/get',
    method: 'post',
    data
  })
}

export function settingSet(data) {
  return service({
    url: '/api/setting/set',
    method: 'post',
    data
  })
}
